import { cn } from "@/lib/utils";
import { CollapseButton } from "../atoms/CollapseButton";

interface SidebarHeaderProps {
  /** Whether the sidebar is currently collapsed */
  isCollapsed: boolean;
  /** Callback when the collapse button is clicked to toggle collapse state */
  onToggle: () => void;
  /** Optional logo rendered alongside the collapse toggle */
  logo?: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
}

/**
 * SidebarHeader - Molecule component
 *
 * Header area for the sidebar containing logo/branding and collapse toggle button.
 * Logo and the collapse toggle sit on the same row in both collapsed and expanded
 * states. Accepts a custom logo component for flexibility.
 */
export function SidebarHeader({ isCollapsed, onToggle, logo, className }: SidebarHeaderProps) {
  const headerClasses = cn("w-full shrink-0 bg-background", className);

  const rowClasses = isCollapsed
    ? "flex items-center justify-center gap-1 px-1 py-2"
    : "flex items-center justify-between px-3 py-2";

  return (
    <div className={headerClasses}>
      <div className={rowClasses}>
        {logo}
        <CollapseButton isCollapsed={isCollapsed} onToggle={onToggle} />
      </div>
    </div>
  );
}
